import { FeedbackConst } from "./feedbackConst";
import { FeedbackController } from "./Feedback";

let feedbackModule = angular.module("sd.feedback.component", []);

feedbackModule
  .component("sdFeedback", {
    controller: FeedbackController,
    templateUrl: "../ServiceDesk/feedback/feedback.html"
  })
  .constant("feedbackConst", new FeedbackConst());

export default feedbackModule;
